import { createAsyncThunk } from '@reduxjs/toolkit';

import { handleListFetch } from '../apiHelpers';

import { APIRoleUserGroupDelete,APIRoleUserGroupGetList, APIRoleUserGroupPost } from './RoleUserGroup.api';

export const fetchRoleUserGroup = createAsyncThunk('roles/fetchRoleUserGroup', async (params: { tenantId: string, userGroupId: string, signal?: AbortSignal }) => {
    const response = await APIRoleUserGroupGetList(params);
    return response.data.map(row => ({
        ...row,
        id: row.roleId,
        name: row.roleName
    }));
});

export const postRoleUserGroup = createAsyncThunk('roles/postRoleUserGroup', async (item: { tenantId: string, roleId: string, userGroupId: string }) => {
    const response = await APIRoleUserGroupPost(item);
    const rows = await handleListFetch(APIRoleUserGroupGetList({ tenantId: item.tenantId, userGroupId: item.userGroupId }));
    return {
        item,
        response,
        rows: rows.map(row => ({
            ...row,
            id: row.roleId,
            name: row.roleName
        })),
    };
});

export const deleteRoleUserGroup = createAsyncThunk('roles/deleteRoleUserGroup', async (item: { tenantId: string, roleId: string, userGroupId: string}) => {
    const response = await APIRoleUserGroupDelete(item);
    const rows = await handleListFetch(APIRoleUserGroupGetList({ tenantId: item.tenantId, userGroupId: item.userGroupId }));
    return {
        item,
        response,
        rows: rows.map(row => ({
            ...row,
            id: row.roleId,
            name: row.roleName
        })),
    };
});
